/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Corporate_Finance_ProjectsInputs */

const en_corporate_finance_projects = /** @type {(inputs: Corporate_Finance_ProjectsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Finance Projects`)
};

const nl_corporate_finance_projects = /** @type {(inputs: Corporate_Finance_ProjectsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Finance Projecten`)
};

/**
* | output |
* | --- |
* | "Finance Projects" |
*
* @param {Corporate_Finance_ProjectsInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const corporate_finance_projects = /** @type {((inputs?: Corporate_Finance_ProjectsInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Corporate_Finance_ProjectsInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_corporate_finance_projects(inputs)
	return en_corporate_finance_projects(inputs)
});